import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgCircleXmark = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M9.152 9.152c.33-.327.865-.327 1.164 0l1.652 1.656 1.684-1.656c.33-.327.865-.327 1.164 0 .359.33.359.865 0 1.164l-1.624 1.652 1.624 1.684c.359.33.359.865 0 1.164-.299.359-.833.359-1.164 0l-1.684-1.624-1.652 1.624c-.299.359-.833.359-1.164 0-.327-.299-.327-.833 0-1.164l1.656-1.684-1.656-1.652c-.327-.299-.327-.833 0-1.164M21 12a9 9 0 0 1-9 9 9 9 0 0 1-9-9 9 9 0 0 1 9-9 9 9 0 0 1 9 9m-9-7.312A7.31 7.31 0 0 0 4.688 12 7.31 7.31 0 0 0 12 19.313 7.31 7.31 0 0 0 19.313 12 7.31 7.31 0 0 0 12 4.688"
    }));
export default SvgCircleXmark;
